import { baseApi, apiTags } from "./baseApi";
import type { Task, CreateTaskParams, UpdateTaskParams } from "./types/api.types";

export const tasksApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getTasks: builder.query<Task[], void>({
            query: () => ({
                resource: "crm-task",
                action: "index",
                method: "GET",
            }),
            providesTags: (result) =>
                result && Array.isArray(result)
                    ? [
                          { type: apiTags.Task, id: "LIST" },
                          ...result.map((item) => ({ type: apiTags.Task, id: item.id })),
                      ]
                    : [{ type: apiTags.Task, id: "LIST" }],
        }),
        getTaskById: builder.query<Task, number>({
            query: (id) => ({
                resource: "crm-task",
                action: "index",
                method: "GET",
                id: id,
                queryBuilder: (query: any) => {
                    return query.where("id", id).first();
                },
            }),
            providesTags: (result, error, arg) => (result ? [{ type: apiTags.Task, id: arg }] : []),
        }),
        createTask: builder.mutation<Task, CreateTaskParams>({
            query: (data) => ({
                resource: "crm-task",
                action: "create",
                method: "POST",
                data: data,
            }),
            invalidatesTags: [{ type: apiTags.Task, id: "LIST" }],
        }),
        updateTask: builder.mutation<Task, UpdateTaskParams>({
            query: ({ id, data }) => ({
                resource: "crm-task",
                action: "update",
                method: "PUT",
                id: id,
                data: data,
            }),
            invalidatesTags: (result, error, arg) => [
                { type: apiTags.Task, id: arg.id },
                { type: apiTags.Task, id: "LIST" },
            ],
        }),
    }),
});

export const {
    useGetTasksQuery,
    useGetTaskByIdQuery,
    useCreateTaskMutation,
    useUpdateTaskMutation,
} = tasksApi;
